// Turns a saved cron expression back into the settings the schedule generator shows.
// Returns null when the expression is not one the generator can make.
const NUMBER = /^\d{1,2}$/;
export const QUARTER = '1,4,7,10';   // January, April, July, October
export const HALF = '1,7';            // January, July

export function parseCron(cron) {
  const parts = String(cron || '').trim().split(/\s+/);
  if (parts.length !== 5) return null;
  const [minute, hour, dayOfMonth, month, dayOfWeek] = parts;
  const base = { hour: '9', minute: '0', dayOfWeek: '1', dayOfMonth: '1' };

  if (month !== '*') {
    if (!NUMBER.test(minute) || !NUMBER.test(hour) || !NUMBER.test(dayOfMonth) || dayOfWeek !== '*') return null;
    const when = { ...base, hour, minute, dayOfMonth };
    if (month === QUARTER) return { ...when, frequency: 'quarterly' };
    if (month === HALF) return { ...when, frequency: 'semiannual' };
    if (/^([1-9]|1[0-2])$/.test(month)) return { ...when, frequency: 'annual', month };
    return null;
  }
  if (cron.trim() === '*/15 * * * *') return { ...base, frequency: 'every15min' };
  if (!NUMBER.test(minute)) return null;
  if (hour === '*' && dayOfMonth === '*' && dayOfWeek === '*') return { ...base, frequency: 'hourly', minute };
  if (!NUMBER.test(hour)) return null;
  if (dayOfMonth === '*' && dayOfWeek === '*') return { ...base, frequency: 'daily', hour, minute };
  if (dayOfMonth === '*' && /^[0-7]$/.test(dayOfWeek)) return { ...base, frequency: 'weekly', hour, minute, dayOfWeek };
  if (dayOfWeek === '*' && NUMBER.test(dayOfMonth)) return { ...base, frequency: 'monthly', hour, minute, dayOfMonth };
  return null;
}
